module.exports = __webpack_public_path__ + "img/85200.7b04c33b.jpg";